module.exports = "/_next/static/images/DataDrivenReport@2x-76a9808afb4b21d6a4fac619909a8253.webp";